module.exports = __webpack_public_path__ + "img/subject_banner1.a9d44069.png";